import type { ApiError } from '@festina/legalentity-general-types/legalentity'
import { useAuthenticationContext } from '@festina-life/authentication'
import { typeUtils } from '@festina-life/core'

import {
  formatInternalServerError,
  formatIssues,
  isValidationErrorMessage,
} from '../../utility/errors'
import { isApiError } from './utils'

type Props = {
  error: unknown
}

const errorToApiMessage = (error: ApiError) => {
  const messageMapping: Record<number, string> = {
    500: formatInternalServerError(error),
  }

  const bodyString = typeof error.body === 'string' ? error.body : undefined
  const message = messageMapping[error.status] ?? bodyString
  return message ? <div>{message}</div> : null
}

export const ErrorMessageBody = ({ error }: Props) => {
  // Given that error messages may be mounted outside of the UiProvider,
  // we deliberately choose to use the authentication context to determine whenther test mode is enabled
  const { isInTestMode } = useAuthenticationContext()

  return (
    <div className="flex flex-col gap-2 shrink overflow-auto">
      {isApiError(error) && isValidationErrorMessage(error.body) && (
        <div>{formatIssues(error.body)}</div>
      )}

      {/* Show technical information for test and dev, should be hidden from real users. */}
      {isInTestMode && (
        <>
          {typeUtils.isError(error) && <div>{error.message}</div>}
          {isApiError(error) && (
            <>
              {errorToApiMessage(error)}
              {error.request && (
                <div>
                  {[error.request?.method, error.url].filter(Boolean).join(' ')}
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}
